module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-18.17e433d9.png";